import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const LuckyLions = () => (
  <StaticQuery
    query=
      {graphql`
        query {
          bg: file(relativePath: { eq: "games/5-lucky-lions.png" }) {
            childImageSharp {
              fluid(maxWidth: 1200) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `}
    render={data => (
      <div className="game-banner">
        {data.bg.childImageSharp.fluid &&
          <Img alt="5 Lucky Lions" fluid={data.bg.childImageSharp.fluid}/>
        }
      </div>
    )}
  />
);

export default LuckyLions;